import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import SpellcheckIcon from '@mui/icons-material/Spellcheck';
import Divider from '@mui/material/Divider';


// import EastIcon from '@mui/icons-material/East';
import { TextField } from '@mui/material';

import { styled } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';


const BootstrapInput = styled(InputBase)(({ theme }) => ({
  '& .MuiInputBase-input': {
    borderRadius: 4,
    position: 'relative',
    border: '1px solid gray', // Set the border color to gray
    fontSize: 16,
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    color: 'lightgray', // Set text color to light gray
    height: '55px', // Set input height to 55px
    width: '20rem',
    boxSizing: 'border-box', // Ensure padding is included in height
    '&:focus': {
      borderRadius: 4,
      borderColor: 'gray', // Keep the border color gray on focus
      boxShadow: 'none',   // Remove any default shadow on focus
    },
  },
}));

function CustomizedSelects() {
  const [age, setAge] = React.useState('');
  const handleChange = (event) => {
    setAge(event.target.value);
  };

  return (
    <div>
      <TextField
        label={"Enter Edit-Command"}
        size="medium"
        variant="outlined"
        sx={{
          width: '20vw',
          '& label': {
            color: 'lightgray',
          },
          '& label.Mui-focused': {
            color: 'gray',
          },
          '& .MuiInputBase-input': {
            color: 'lightgray',
          },
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: 'gray',
            },
            '&:hover fieldset': {
              borderColor: 'gray',
            },
            '&.Mui-focused fieldset': {
              borderColor: 'gray',
            },
          },
          margin: "0 2rem"
        }}
      />
    </div>
  );
}

// export default CustomizedSelects;



const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: "35vw",
  bgcolor: '#242424',
  boxShadow: 24,
  p: 4,
};


const names = [
  'Ubuntu 18.04',
  'Windows 11',
  'Linux'
];

const ITEM_HEIGHT = 68;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 550,
    },
  },
};

export default function AssignToTemplateModal() {
  const [open, setOpen] = React.useState(false);
  const [imageName, setImageName] = React.useState([]);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setImageName(
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  return (
    <IconButton aria-label="share" sx={{ color: 'lightgray' }}>
      <Tooltip
        title="Edit and Commit"
        componentsProps={{
          tooltip: {
            sx: {
              backgroundColor: 'lightgray',
              color: 'black',
              fontSize: '0.9rem',
            },
          },
        }}
      >
        <IconButton sx={{ color: 'lightgray' }}>
          <SpellcheckIcon onClick={handleOpen} />
        </IconButton>
      </Tooltip>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: "lightgray", fontWeight: "900" }}>
            Edit and Commit
          </Typography>
          <Divider sx={{ backgroundColor: 'lightgray', margin: "2rem 0" }} />
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <CustomizedSelects />
            <Button
              component="label"
              role={undefined}
              variant="contained"
              tabIndex={-1}
              // startIcon={'Assign'}
              sx={{
                width: "7rem",
                backgroundColor: 'transparent',
                border: "1px solid gray",
                color: 'white',
                '&:hover': {
                  backgroundColor: 'transparent',
                },
                height: "55px",
                display: "flex",
                alignItems: "center"
              }}
            >
              Commit
            </Button>
          </div>
        </Box>
      </Modal>
    </IconButton>
  );
}
